import { TableFilterDTO } from '../../global';
import { DriverDTO } from '../../services/driver.service';
import { DeviceDTO } from '../../services/device.service';
import { TeamLightDTO } from '../../services/team.service';
import { TransportType } from '../../shared/types';
import { GroupLightDTO } from '../../services/group.service';

export enum EngineType {
  DIESEL = 'DIESEL',
  GASOLINE = 'GASOLINE',
  HYBRID = 'HYBRID',
  ELECTRICAL = 'ELECTRICAL',
}
export enum UnitOfMeasure {
  LITRE = 'LITRE',
  KILOWATT = 'KILOWATT',
  CUBICMETRE = 'CUBIC METRE',
}

export type VehicleFormDTO = {
  image: string;
  name: string;
  type: TransportType;
  licensePlate: string;
  mileage: string;
  fuelType: EngineType | string;
  measure: UnitOfMeasure;
  team: TeamLightDTO | null;
  group: GroupLightDTO[] | [];
  vin: string;
  courier: DriverDTO | null;
  device: DeviceDTO | null;
  avgConsumption: number;
};

export type VehicleListFilterDTO = TableFilterDTO & {
  vehicleType?: string;
};

export const enum SearchOption {
  NAME = 'name',
  LICENSE_PLATE = 'licensePlate',
  VEHICLE_TYPE = 'vehicleType',
  COURIER_FIRST_NAME = 'courier:firstName',
  COURIER_LAST_NAME = 'courier:lastName',
  TEAM = 'team:name',
}
export enum ModalActionType {
  TEAM = 'team',
  DELETE_VEHICLES = 'DELETE_VEHICLES',
}
